import { Tabs as AntTabs, Tooltip } from "antd"
import type { TabsProps } from "antd"
import { UploadDocs } from "../../pages/UploadDocs"
import { useTranslation } from "react-i18next"
import { CopyArticles } from "../../pages/CopyArticles"
import { getStorageVariable } from "../../utils/storage"
import {
  tabs,
  STORAGE_ENCRYPTED_DATA,
  WEB_PORTALS,
  backupTabs,
} from "../../constants"
import { UploadImages } from "../../pages/ImageUpload"
import { SharePosts } from "../../pages/SharePosts"
import { BackupFileList } from "../../pages/Backup"
import { ClearCache } from "../../pages/ClearCache"

const { UPLOAD, COPY, IMAGE_UPLOAD, SHARE_POST, CLEAR_CACHE } = tabs
const { WORD_FILES, KN_IMAGES, FTN_IMAGES } = backupTabs
const { czechCryptoNews, czechFtNews } = WEB_PORTALS

const defaultTabKey = UPLOAD

const areFtnCzCredentialsDefined = getStorageVariable(
  `${czechFtNews}${STORAGE_ENCRYPTED_DATA}`,
)
const areKnCzCredentialsDefined = getStorageVariable(
  `${czechCryptoNews}${STORAGE_ENCRYPTED_DATA}`,
)

const isCopyTabDisabled =
  !areFtnCzCredentialsDefined && !areKnCzCredentialsDefined

export const Tabs: React.FC = () => {
  const { t } = useTranslation()

  const items: TabsProps["items"] = [
    {
      key: UPLOAD,
      label: t("menu.uploading"),
      children: <UploadDocs />,
    },
    {
      key: IMAGE_UPLOAD,
      label: t("menu.imageUpload"),
      children: <UploadImages />,
    },
    {
      key: CLEAR_CACHE,
      label: t("menu.cacheClearing"),
      children: <ClearCache />,
    },
    {
      key: SHARE_POST,
      label: t("menu.sharePost"),
      children: <SharePosts />,
      disabled: true, // Temporarily disable the Share Post tab
    },
    {
      key: COPY,
      label: isCopyTabDisabled ? (
        <Tooltip title={t("menu.copyingTooltip")}>{t("menu.copying")}</Tooltip>
      ) : (
        t("menu.copying")
      ),
      children: <CopyArticles />,
      disabled: isCopyTabDisabled,
    },
  ]

  return <AntTabs centered defaultActiveKey={defaultTabKey} items={items} />
}

export const BackupTabs: React.FC = () => {
  const { t } = useTranslation()

  const items: TabsProps["items"] = [
    {
      key: WORD_FILES,
      label: t("menu.wordFiles"),
      children: <BackupFileList type="word" category={WORD_FILES} />,
    },
    {
      key: KN_IMAGES,
      label: t("menu.knImages"),
      children: <BackupFileList type="image" category={KN_IMAGES} />,
    },
    {
      key: FTN_IMAGES,
      label: t("menu.ftnImages"),
      children: <BackupFileList type="image" category={FTN_IMAGES} />,
    },
  ]

  return <AntTabs centered defaultActiveKey={defaultTabKey} items={items} />
}
